import { apiJson } from '../api';
import type { ArticleFollowResult, Feed } from '../types';

export interface CreateFeedRequest {
  feed_url: string;
  title?: string;
  description?: string;
}

export interface UpdateFeedRequest {
  feed_url?: string;
  title?: string;
  description?: string;
}

export async function listFeeds(): Promise<Feed[]> {
  const data = await apiJson<Feed[]>('/api/feeds');
  return Array.isArray(data) ? data : [];
}

export async function createFeed(feed: CreateFeedRequest): Promise<Feed> {
  return apiJson<Feed>('/api/feeds', {
    method: 'POST',
    json: feed,
  });
}

export async function updateFeed(feedId: string, feed: UpdateFeedRequest): Promise<Feed> {
  return apiJson<Feed>(`/api/feeds/${encodeURIComponent(feedId)}`, {
    method: 'PATCH',
    json: feed,
  });
}

export async function deleteFeed(feedId: string): Promise<void> {
  await apiJson(`/api/feeds/${encodeURIComponent(feedId)}`, {
    method: 'DELETE',
  });
}

export interface FeedRefreshResult {
  feed_url: string;
  inserted: number;
  skipped_duplicate?: number;
  skipped_old?: number;
  tracked_as_site?: boolean;
  error?: string;
}

export async function refreshMyFeeds(): Promise<{ results: FeedRefreshResult[] }> {
  return apiJson<{ results: FeedRefreshResult[] }>('/api/feeds/refresh', {
    method: 'POST',
  });
}

export async function subscribeFeed(feedUrl: string, title?: string): Promise<Feed> {
  return createFeed({ feed_url: feedUrl, title });
}

export async function followArticle(url: string): Promise<ArticleFollowResult> {
  return apiJson<ArticleFollowResult>('/api/me/follows', {
    method: 'POST',
    json: { url },
  });
}

export interface FeedElement {
  id: string;
  title?: string;
  url?: string;
  canonical_domain?: string;
  published_at?: string;
  created_at?: string;
  tier?: number;
  summary?: string;
  feed_id?: string;
  feed_name?: string;
}

export async function listFeedElements(feedId?: string): Promise<FeedElement[]> {
  const params = new URLSearchParams();
  if (feedId) params.set('feed_id', feedId);
  const url = '/api/feeds/elements' + (params.toString() ? '?' + params.toString() : '');
  const data = await apiJson<FeedElement[]>(url);
  return Array.isArray(data) ? data : [];
}
